export default function formatNumber(number) {
  number = parseFloat(number)
  if(typeof number !== 'number') return ''

  return number.toLocaleString('uk-UA')
}
